
import React from "react";
import { FaArrowRight } from "react-icons/fa";

import VideoBg from "../../../assets/videos/bgempresa.mp4"

function EmpresaHero() {
    return (
        <section className="empresa-hero">
            {/* Video de fondo */}
            <video
                className="empresa-hero-video"
                autoPlay
                muted
                loop
                playsInline
                preload="metadata"
                aria-hidden="true"
                tabIndex={-1}
            >
                <source
                    src={VideoBg}
                    type="video/mp4"
                />
            </video>

            {/* Capa oscura para conservar el estilo */}
            <div
                className="empresa-hero-overlay"
                aria-hidden="true"
            />

            {/* Elemento orbital decorativo */}


            {/* Contenido principal */}
            <div className="empresa-hero-content">

                <h1>
                    Innovamos
                    <br />
                    <span>para transformar.</span>
                </h1>

                <p>
                    Tecnología, creatividad y visión estratégica
                    para construir nuevas posibilidades.
                </p>

                <a
                    href="#empresa-identidad"
                    className="empresa-text-link"
                >
                    DESCUBRE QUIÉNES SOMOS
                    <span>
            <FaArrowRight />
          </span>
                </a>
            </div>

            {/* Información inferior */}
        </section>
    );
}

export default EmpresaHero;
